// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as Video$Showside from "../utils/Video.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as IframeEmbed$Showside from "../utils/IframeEmbed.bs.js";
import * as WebapiUtils$Showside from "../utils/WebapiUtils.bs.js";
import * as WebapiVideo$Showside from "../utils/WebapiVideo.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as QuickViewTabs$Showside from "./QuickViewTabs.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as UseAutoplayProgress$Showside from "../hook/UseAutoplayProgress.bs.js";
function QuickViewMedia$TapToPause(Props) {
  var children = Props.children;
  var onPause = Props.onPause;
  var match = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var $$clearTimeout = match.clearTimeout;
  var $$setTimeout = match.setTimeout;
  var handleTouchStart = function (param) {
    Curry._1($$clearTimeout, undefined);
    $$setTimeout(function (param) {
      Curry._1(onPause, true);
    }, 250);
  };
  var handleTouchEnd = function (param) {
    Curry._1($$clearTimeout, undefined);
    $$setTimeout(function (param) {
      Curry._1(onPause, false);
    }, 42);
  };
  var handleContextMenu = function (e) {
    e.preventDefault();
  };
  var className = CSS$Showside.prefix("absolute inset-0 select-none no-touch-callout");
  return React.createElement("div", {
    className: className,
    onContextMenu: handleContextMenu,
    onTouchEnd: handleTouchEnd,
    onTouchStart: handleTouchStart
  }, children);
}
QuickViewMedia$TapToPause.displayName = "QuickViewMedia.TapToPause";
var TapToPause = {
  make: QuickViewMedia$TapToPause
};
function _getSize(element, src) {
  var width = element.videoWidth;
  var height = element.videoHeight;
  if (width === 0 && height === 0) {
    return new Promise(function (resolve, reject) {
      setTimeout(function (param) {
        _getSize(element, src).then(function (result) {
          resolve(result);
        });
      }, 42);
    });
  }
  Belt_Option.forEach(Caml_option.nullable_to_opt(element.parentElement), function (parent) {
    parent.removeChild(element);
  });
  return Promise.resolve([src, width, height]);
}
function getSize(src) {
  return new Promise(function (resolve, reject) {
    var element = document.createElement("video");
    element.setAttribute("src", src);
    element.setAttribute("preload", "metadata");
    Belt_Option.forEach(WebapiUtils$Showside.$$Document.body(document), function (param) {
      param.appendChild(element);
    });
    _getSize(element, src).then(function (result) {
      resolve(result);
    });
  });
}
function QuickViewMedia$Video(Props) {
  var src = Props.src;
  var fwdRef = Props.fwdRef;
  var isPaused = Props.isPaused;
  var onReady = Props.onReady;
  var poster = Props.poster;
  var onTimeChange = Props.onTimeChange;
  var initialTime = Props.initialTime;
  var muted = Props.muted;
  var onEnded = Props.onEnded;
  var loopOpt = Props.loop;
  var controlsOpt = Props.controls;
  var objectFit = Props.objectFit;
  var onMute = Props.onMute;
  var mediaIndexOpt = Props.mediaIndex;
  var activeMediaIndexOpt = Props.activeMediaIndex;
  var loop = loopOpt !== undefined ? loopOpt : true;
  var controls = controlsOpt !== undefined ? controlsOpt : false;
  var mediaIndex = mediaIndexOpt !== undefined ? mediaIndexOpt : 0;
  var activeMediaIndex = activeMediaIndexOpt !== undefined ? activeMediaIndexOpt : 0;
  var isPaused$1 = isPaused || mediaIndex !== activeMediaIndex;
  var ref = React.useRef(null);
  var ref$1 = fwdRef !== undefined ? fwdRef : ref;
  var pause = function (param) {
    Belt_Option.forEach(Caml_option.nullable_to_opt(ref$1.current), function (e) {
      e.pause();
    });
  };
  var handlePause = function (pause) {
    Belt_Option.forEach(Caml_option.nullable_to_opt(ref$1.current), function (element) {
      var pause$1 = pause || Belt_Option.getWithDefault(Caml_option.nullable_to_opt(element.getAttribute("class")), "").includes("QVTW__video-paused");
      if (pause$1) {
        element.pause();
      } else {
        element.play();
      }
    });
  };
  var play = React.useCallback(function (param) {
    Belt_Option.map(Caml_option.nullable_to_opt(ref$1.current), function (el) {
      return WebapiVideo$Showside.playWithRetries(onMute, el);
    });
  }, [src]);
  var onCanPlay = function (param) {
    if (isPaused$1) {
      return;
    } else {
      Curry._1(play, undefined);
      return Curry._1(onReady, undefined);
    }
  };
  var onEnded$1 = Belt_Option.map(onEnded, function (fn, param) {
    Curry._1(fn, undefined);
  });
  React.useEffect(function () {
    if (isPaused$1) {
      pause(undefined);
    } else {
      onCanPlay(undefined);
    }
  }, [isPaused$1]);
  var match = Video$Showside.Hls.isHls(src);
  var match$1 = Math.abs(mediaIndex - activeMediaIndex | 0) < 2;
  var tmp;
  var exit = 0;
  if (match) {
    if (match$1) {
      exit = 1;
    } else {
      tmp = null;
    }
  } else if (isPaused$1) {
    tmp = null;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    var tmp$1 = {
      src: src,
      controls: controls,
      loop: loop,
      width: "100%",
      height: "100%",
      videoRef: ref$1,
      onCanPlay: onCanPlay,
      onLoadedMetadata: onCanPlay,
      position: "absolute",
      className: isPaused$1 ? CSS$Showside.prefix("video-paused") : "",
      key: src
    };
    if (muted !== undefined) {
      tmp$1.muted = Caml_option.valFromOption(muted);
    }
    if (poster !== undefined) {
      tmp$1.poster = Caml_option.valFromOption(poster);
    }
    if (onEnded$1 !== undefined) {
      tmp$1.onEnded = Caml_option.valFromOption(onEnded$1);
    }
    if (objectFit !== undefined) {
      tmp$1.objectFit = Caml_option.valFromOption(objectFit);
    }
    if (onTimeChange !== undefined) {
      tmp$1.onTimeChange = Caml_option.valFromOption(onTimeChange);
    }
    if (initialTime !== undefined) {
      tmp$1.initialTime = Caml_option.valFromOption(initialTime);
    }
    tmp = React.createElement(Video$Showside.make, tmp$1);
  }
  return React.createElement(QuickViewMedia$TapToPause, {
    children: null,
    onPause: handlePause
  }, poster !== undefined ? React.createElement(SmartImg$Showside.make, {
    src: poster,
    fit: objectFit === "contain" ? /* Contain */2 : /* Cover */1,
    priority: 0
  }) : null, tmp);
}
QuickViewMedia$Video.displayName = "QuickViewMedia.Video";
var Video = {
  _getSize: _getSize,
  getSize: getSize,
  make: QuickViewMedia$Video
};
function QuickViewMedia$Image(Props) {
  var src = Props.src;
  var alt = Props.alt;
  var onReady = Props.onReady;
  var onPauseAutoplay = Props.onPauseAutoplay;
  return React.createElement(QuickViewMedia$TapToPause, {
    children: React.createElement(SmartImg$Showside.make, {
      src: src,
      fit: /* Cover */1,
      alt: alt,
      priority: 0,
      onLoad: function ($$event) {
        Curry._1(onReady, $$event);
      }
    }),
    onPause: onPauseAutoplay
  });
}
QuickViewMedia$Image.displayName = "QuickViewMedia.Image";
var $$Image = {
  make: QuickViewMedia$Image
};
function QuickViewMedia$Album$AlbumBrowser(Props) {
  var index = Props.index;
  var total = Props.total;
  var media = Props.media;
  var allAlbumMedia = Props.allAlbumMedia;
  var onChangeIndex = Props.onChangeIndex;
  var children = Props.children;
  var isMobile = Props.isMobile;
  var isStories = Props.isStories;
  var isPaused = Props.isPaused;
  var canGoNext = Props.canGoNext;
  var canGoPrevious = Props.canGoPrevious;
  var overlay = Props.overlay;
  var autoplay = Props.autoplay;
  var autoplayPaused = Props.autoplayPaused;
  var progress = Props.progress;
  var progressSpeed = Props.progressSpeed;
  var setProgressRef = Props.setProgressRef;
  var onPauseAutoplay = Props.onPauseAutoplay;
  var className = CSS$Showside.prefix("absolute inset-0 select-none transform");
  var nextIcon = React.createElement("div", {
    className: CSS$Showside.prefix("absolute top-1/2 transform -translate-y-1/2 right-3 rounded-full w-12 h-12 bg-white opacity-50 group-1-hover:opacity-80 text-black flex items-center justify-center transform rotate-180")
  }, React.createElement(Unicons$Showside.UilAngleLeftB.make, {}));
  var prevIcon = React.createElement("div", {
    className: CSS$Showside.prefix("absolute top-1/2 transform -translate-y-1/2 left-3 rounded-full w-12 h-12 bg-white opacity-50 group-1-hover:opacity-80 text-black flex items-center justify-center")
  }, React.createElement(Unicons$Showside.UilAngleLeftB.make, {}));
  var goNext = React.createElement(ConditionalRender$Showside.When.make, {
    condition: canGoNext,
    children: React.createElement(DataAttribute$Showside.make, {
      dataTestId: "qv-album-next",
      children: React.createElement("div", {
        className: CSS$Showside.prefix("group-1 absolute top-0 right-0 w-3/4 h-full cursor-pointer no-touch-highlight"),
        onClick: function (param) {
          Curry._1(onChangeIndex, index + 1 | 0);
        }
      }, React.createElement(QuickViewMedia$TapToPause, {
        children: React.createElement(ConditionalRender$Showside.When.make, {
          condition: !isMobile,
          children: nextIcon
        }),
        onPause: onPauseAutoplay
      }))
    })
  });
  var goPrevious = React.createElement(ConditionalRender$Showside.When.make, {
    condition: canGoPrevious,
    children: React.createElement(DataAttribute$Showside.make, {
      dataTestId: "qv-album-previous",
      children: React.createElement("div", {
        className: CSS$Showside.prefix("group-1 absolute top-0 left-0 w-1/4 h-full cursor-pointer no-touch-highlight"),
        onClick: function (param) {
          Curry._1(onChangeIndex, index - 1 | 0);
        }
      }, React.createElement(QuickViewMedia$TapToPause, {
        children: React.createElement(ConditionalRender$Showside.When.make, {
          condition: !isMobile,
          children: prevIcon
        }),
        onPause: onPauseAutoplay
      }))
    })
  });
  var tmp = {
    index: index,
    total: total,
    onClick: onChangeIndex,
    align: isStories ? "top" : isMobile ? {
      NAME: "arbBottom",
      VAL: 36
    } : "bottom",
    style: isStories ? "line" : "circle",
    gradient: true,
    dataTestId: "qv-album-tabs"
  };
  if (autoplay !== undefined) {
    tmp.autoplay = Caml_option.valFromOption(autoplay);
  }
  if (autoplayPaused !== undefined) {
    tmp.autoplayPaused = Caml_option.valFromOption(autoplayPaused);
  }
  if (progress !== undefined) {
    tmp.progress = progress;
  }
  if (progressSpeed !== undefined) {
    tmp.progressSpeed = progressSpeed;
  }
  if (setProgressRef !== undefined) {
    tmp.setProgressRef = Caml_option.valFromOption(setProgressRef);
  }
  var tmp$1 = isMobile ? "full" : undefined;
  if (tmp$1 !== undefined) {
    tmp.size = Caml_option.valFromOption(tmp$1);
  }
  var tabs = React.createElement("div", {
    className: CSS$Showside.prefix("fixed top-0 left-0 w-full h-full pointer-events-none")
  }, React.createElement(QuickViewTabs$Showside.make, tmp));
  var imageCache = Belt_Array.map(allAlbumMedia, function (media) {
    var imgUrl = media.fallbackImageUrl;
    return React.createElement("div", {
      className: CSS$Showside.prefix("opacity-0 pointer-events-none absolute inset-0")
    }, React.createElement(SmartImg$Showside.make, {
      src: imgUrl !== undefined ? imgUrl : media.src,
      fit: /* Contain */2,
      alt: Belt_Option.getWithDefault(media.title, "Image foreground"),
      priority: 1
    }));
  });
  var imgUrl = media.fallbackImageUrl;
  var backdrop = React.createElement(SmartImg$Showside.ColorOverlay.make, {
    src: imgUrl !== undefined ? imgUrl : media.src
  });
  return React.createElement("div", {
    className: className
  }, backdrop, children, React.createElement(ConditionalRender$Showside.When.make, {
    condition: !isPaused,
    children: null
  }, goNext, goPrevious, overlay, tabs, imageCache));
}
QuickViewMedia$Album$AlbumBrowser.displayName = "QuickViewMedia.Album.AlbumBrowser";
var AlbumBrowser = {
  make: QuickViewMedia$Album$AlbumBrowser
};
function QuickViewMedia$Album(Props) {
  var allMedia = Props.allMedia;
  var media = Props.media;
  var mediaChildren = Props.mediaChildren;
  var isPaused = Props.isPaused;
  var isMobile = Props.isMobile;
  var isStories = Props.isStories;
  var initialTime = Props.initialTime;
  var muted = Props.muted;
  var controls = Props.controls;
  var shouldAutoplay = Props.shouldAutoplay;
  var renderOverlay = Props.renderOverlay;
  var goToPrevSlide = Props.goToPrevSlide;
  var goToNextSlide = Props.goToNextSlide;
  var onReady = Props.onReady;
  var onPauseAutoplay = Props.onPauseAutoplay;
  var onAlbumMediaChange = Props.onAlbumMediaChange;
  var onMute = Props.onMute;
  var match = RouterProvider$Showside.useRouter(undefined);
  var goTo = match.goTo;
  var route = match.route;
  var match$1 = React.useState(function () {
    return 0;
  });
  var setLastIndex = match$1[1];
  var lastIndex = match$1[0];
  var loopCarousel = !isStories;
  var curAlbumIndex;
  if (typeof route === "number" || route.TAG !== /* QuickView */3) {
    curAlbumIndex = lastIndex;
  } else {
    var albumId = route._0.albumId;
    curAlbumIndex = Belt_Option.getWithDefault(Belt_Array.getIndexBy(mediaChildren, function (media) {
      return Caml_obj.equal(media.id, albumId);
    }), lastIndex);
  }
  var curMediaIndex = Belt_Option.getWithDefault(Belt_Array.getIndexBy(allMedia, function (media0) {
    return media0.id === media.id;
  }), 0);
  var setIndex = function (nextIndex) {
    Curry._1(setLastIndex, function (param) {
      return nextIndex;
    });
    var mediaByIndex = Belt_Array.get(mediaChildren, nextIndex);
    var currentRoute;
    currentRoute = typeof route === "number" || route.TAG !== /* QuickView */3 ? undefined : route._0;
    if (currentRoute !== undefined) {
      return Curry._3(goTo, undefined, undefined, {
        TAG: /* QuickView */3,
        _0: {
          mediaId: currentRoute.mediaId,
          mediaParentId: currentRoute.mediaParentId,
          albumId: Belt_Option.map(mediaByIndex, function (media) {
            return media.id;
          }),
          productId: currentRoute.productId,
          relatedMediaProductIds: currentRoute.relatedMediaProductIds,
          relatedMediaCategoryId: currentRoute.relatedMediaCategoryId,
          variantId: currentRoute.variantId,
          panelClosed: currentRoute.panelClosed,
          zoomedPhotoIndex: currentRoute.zoomedPhotoIndex,
          time: currentRoute.time
        }
      });
    }
  };
  var totalAlbumItems = mediaChildren.length;
  var mediaChild = Belt_Array.get(mediaChildren, curAlbumIndex);
  var match$2 = React.useState(function () {
    return {};
  });
  var setIsReadyMap = match$2[1];
  var isReadyMap = match$2[0];
  var isReady = Belt_Option.getWithDefault(Belt_Option.flatMap(mediaChild, function (mediaChild) {
    return Js_dict.get(isReadyMap, mediaChild.id);
  }), false);
  var shouldAutoplay$1 = shouldAutoplay && !isPaused && isReady;
  var onReady$1 = function ($$event) {
    Curry._1(onReady, $$event);
    Curry._1(setIsReadyMap, function (dict) {
      if (mediaChild === undefined) {
        return dict;
      }
      var key = mediaChild.id;
      var value = $$event !== undefined ? $$event.imageSize.width >= $$event.width && $$event.imageSize.height >= $$event.height : mediaChild.kind === "video";
      return Js_dict.fromArray(Belt_Array.concat(Js_dict.entries(dict), [[key, value]]));
    });
  };
  var match$3 = UseAutoplayProgress$Showside.use(shouldAutoplay$1, undefined, Belt_Option.map(mediaChild, function (media) {
    var match = media.kind;
    if (match === "image") {
      return "image";
    } else {
      return "video";
    }
  }), Belt_Option.map(mediaChild, function (media) {
    return media.id;
  }), undefined);
  var setProgress = match$3[1];
  var goToNextMedia = function (param) {
    if (curAlbumIndex >= (totalAlbumItems - 1 | 0)) {
      return Curry._1(goToNextSlide, undefined);
    } else if (curAlbumIndex < (totalAlbumItems - 1 | 0)) {
      return setIndex(curAlbumIndex + 1 | 0);
    } else if (curAlbumIndex < 0) {
      return setIndex(0);
    } else {
      return;
    }
  };
  var autoplayTimerRef = React.useRef(undefined);
  React.useEffect(function () {
    var $$clearTimeout$1 = function (param) {
      var id = autoplayTimerRef.current;
      if (id !== undefined) {
        clearTimeout(Caml_option.valFromOption(id));
        return;
      }
    };
    $$clearTimeout$1(undefined);
    if (shouldAutoplay$1 && mediaChild !== undefined && mediaChild.kind === "image") {
      autoplayTimerRef.current = Caml_option.some(setTimeout(goToNextMedia, 5000));
    }
    return function (param) {
      $$clearTimeout$1(undefined);
    };
  }, [curAlbumIndex, mediaChild, shouldAutoplay$1]);
  var handleVideoTimeChange = function (time, duration) {
    var progress = Math.round(time / duration * 100) | 0;
    if (progress === 100) {
      if (shouldAutoplay$1) {
        return goToNextMedia(undefined);
      } else {
        return;
      }
    } else {
      return Curry._1(setProgress, progress);
    }
  };
  var videoRef = React.useRef(null);
  var onPauseAutoplay$1 = function (pause) {
    Curry._1(onPauseAutoplay, pause);
    if (mediaChild !== undefined && mediaChild.kind === "video") {
      return Belt_Option.forEach(Caml_option.nullable_to_opt(videoRef.current), function (e) {
        if (pause) {
          e.pause();
        } else {
          e.play();
        }
      });
    }
  };
  var mediaElement = React.useMemo(function () {
    if (mediaChild === undefined) {
      return null;
    }
    if (mediaChild.kind === "image") {
      return React.createElement(QuickViewMedia$Image, {
        src: mediaChild.src,
        alt: Belt_Option.getWithDefault(mediaChild.title, "Image media"),
        onReady: onReady$1,
        onPauseAutoplay: onPauseAutoplay$1
      });
    }
    if (mediaChild.kind !== "video") {
      return null;
    }
    var poster = mediaChild.fallbackImageUrl;
    var tmp = {
      src: mediaChild.src,
      fwdRef: videoRef,
      isPaused: isPaused,
      onReady: onReady$1,
      onTimeChange: handleVideoTimeChange,
      initialTime: initialTime,
      muted: muted,
      loop: !shouldAutoplay$1,
      onMute: onMute
    };
    if (poster !== undefined) {
      tmp.poster = Caml_option.valFromOption(poster);
    }
    return React.createElement(QuickViewMedia$Video, tmp);
  }, [mediaChild, isPaused, shouldAutoplay$1, muted]);
  React.useEffect(function () {
    if (isPaused) {} else {
      Belt_Option.forEach(mediaChild, onAlbumMediaChange);
    }
  }, [mediaChild]);
  var handleIndexChange = function (newIndex) {
    if (loopCarousel) {
      if (newIndex < 0) {
        return setIndex(totalAlbumItems - 1 | 0);
      } else if (newIndex >= totalAlbumItems) {
        return setIndex(0);
      } else {
        return setIndex(newIndex);
      }
    } else if (newIndex < 0) {
      return Curry._1(goToPrevSlide, undefined);
    } else if (newIndex >= totalAlbumItems) {
      return goToNextMedia(undefined);
    } else {
      return setIndex(newIndex);
    }
  };
  var overlay = mediaChild !== undefined ? Curry._1(renderOverlay, mediaChild) : null;
  var canGoNext = curAlbumIndex < (totalAlbumItems - 1 | 0) || curMediaIndex < (allMedia.length - 1 | 0) || loopCarousel;
  var canGoPrevious = curAlbumIndex > 0 || curMediaIndex > 0 || loopCarousel;
  if (!controls) {
    return mediaElement;
  }
  var tmp = {
    index: curAlbumIndex,
    total: totalAlbumItems,
    media: media,
    allAlbumMedia: mediaChildren,
    onChangeIndex: handleIndexChange,
    children: mediaElement,
    isMobile: isMobile,
    isStories: isStories,
    isPaused: isPaused,
    canGoNext: canGoNext,
    canGoPrevious: canGoPrevious,
    overlay: overlay,
    autoplay: shouldAutoplay$1,
    autoplayPaused: false,
    setProgressRef: match$3[2],
    onPauseAutoplay: onPauseAutoplay$1
  };
  var tmp$1 = match$3[0];
  if (tmp$1 !== undefined) {
    tmp.progressSpeed = Caml_option.valFromOption(tmp$1);
  }
  return React.createElement(QuickViewMedia$Album$AlbumBrowser, tmp);
}
QuickViewMedia$Album.displayName = "QuickViewMedia.Album";
var Album = {
  AlbumBrowser: AlbumBrowser,
  make: QuickViewMedia$Album
};
function QuickViewMedia$MediaWrapper(Props) {
  var media = Props.media;
  var children = Props.children;
  var className = CSS$Showside.prefix("absolute inset-0 select-none bg-white");
  return React.createElement(DataAttribute$Showside.make, {
    dataTestId: "qv-media",
    dataId: String(media.order),
    children: React.createElement("div", {
      className: className
    }, children)
  });
}
QuickViewMedia$MediaWrapper.displayName = "QuickViewMedia.MediaWrapper";
var MediaWrapper = {
  make: QuickViewMedia$MediaWrapper
};
function renderMedia(allMedia, media, mediaIndex, activeMediaIndex, isPaused, isMobile, isStories, initialTime, onTimeChange, shouldAutoplay, muted, controls, goToSlide, onReady, onMute, onPauseAutoplay, onAlbumMediaChange, renderOverlay, param) {
  var goToNextSlide = function (param) {
    var nextIndex = activeMediaIndex + 1 | 0;
    if (nextIndex < allMedia.length) {
      return Curry._1(goToSlide, nextIndex);
    }
  };
  var goToPrevSlide = function (param) {
    var previousIndex = activeMediaIndex - 1 | 0;
    if (previousIndex >= 0) {
      return Curry._1(goToSlide, previousIndex);
    }
  };
  var match = media.kind;
  var tmp;
  if (typeof match === "object") {
    tmp = React.createElement(QuickViewMedia$Album, {
      allMedia: allMedia,
      media: media,
      mediaChildren: match.VAL,
      isPaused: isPaused,
      isMobile: isMobile,
      isStories: isStories,
      initialTime: initialTime,
      muted: muted,
      controls: controls,
      shouldAutoplay: shouldAutoplay,
      renderOverlay: renderOverlay,
      goToPrevSlide: goToPrevSlide,
      goToNextSlide: goToNextSlide,
      onReady: onReady,
      onPauseAutoplay: onPauseAutoplay,
      onTimeChange: onTimeChange,
      onAlbumMediaChange: onAlbumMediaChange,
      onMute: onMute
    });
  } else if (match === "video") {
    var tmp$1 = {
      src: media.src,
      isPaused: isPaused,
      onReady: onReady,
      onTimeChange: onTimeChange,
      initialTime: initialTime,
      muted: muted,
      onEnded: goToNextSlide,
      loop: !shouldAutoplay,
      onMute: onMute,
      mediaIndex: mediaIndex,
      activeMediaIndex: activeMediaIndex
    };
    if (media.fallbackImageUrl !== undefined) {
      tmp$1.poster = Caml_option.valFromOption(media.fallbackImageUrl);
    }
    tmp = React.createElement(QuickViewMedia$Video, tmp$1);
  } else {
    tmp = match === "placeholder" ? null : match === "image" ? React.createElement(QuickViewMedia$Image, {
      src: media.src,
      alt: Belt_Option.getWithDefault(media.title, "Image media"),
      onReady: onReady,
      onPauseAutoplay: onPauseAutoplay
    }) : React.createElement(IframeEmbed$Showside.make, {
      url: media.src
    });
  }
  return React.createElement(QuickViewMedia$MediaWrapper, {
    isPaused: isPaused,
    isMobile: isMobile,
    goToSlide: goToSlide,
    media: media,
    activeMediaIndex: activeMediaIndex,
    children: tmp
  });
}
export { TapToPause, Video, $$Image, Album, MediaWrapper, renderMedia };
/* react Not a pure module */